<template>
  <div class="container">
    <div class="container-person">
      <div v-for="(items, index) in item" :key="index">
        <button type="button" class="btn person textoverflow">
          <img :src="items.customer_pic" alt class="img-person" />
          {{ items.name }}
          <img
            src="img/icons_v2/icon-close-gray.png"
            class="icon-size"
            @click="removeData(index)"
          />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['item'],

  methods: {
    removeData(index) {
      this.$emit('remove', index)
    }
  }
}
</script>

<style lang="scss" scoped>
.container-person {
  display: flex;
  max-width: 100%;
  overflow: scroll;
}

::-webkit-scrollbar {
  display: none;
}
</style>
